import { ActionTypes } from "../contants/Action.Type";
import { toast } from "react-toastify";
import ApiConnect from "../../Utils/ApiConnect";
import { cartUpdate } from "./Socket.Action";
import CryptoJS from "react-native-crypto-js";

export const CreateNewTable =
  (table, customer, group, target) => (dispatch, getstate) => {
    const oldtext = target.innerHTML;
    target.innerHTML = "Loading...";
    var bodyFormData = new FormData();
    bodyFormData.append("table", table);
    bodyFormData.append("customer", customer);
    ApiConnect({
      method: "post",
      url: "/POS/Inventory/NewTable",
      data: bodyFormData,
    })
      .then((response) => {
        target.innerHTML = oldtext;
        if (response.data.status !== 204) {
          toast.success(response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
          dispatch(RefreshTable());
          dispatch(CartSocketRefresh());
          dispatch(GetCartData(table, group, target));
        } else {
          toast.warning(response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
export const GetQrTableCart = (data) => (dispatch, getstate) => {
  var Loading = true;
  dispatch({ type: ActionTypes.SET_LOADING, payload: Loading });
  let bytes = CryptoJS.AES.decrypt(data, process.env.REACT_APP_API_KEY);
  let table = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  ApiConnect.get(`POS/Inventory/TableDetailInfo?table=` + table)
    .then((response) => {
      const CurrentCart = response.data;
      dispatch({
        type: ActionTypes.SET_CURRENT_CART,
        payload: { CurrentCart },
      });
      Loading = false;
      dispatch({ type: ActionTypes.SET_LOADING, payload: Loading });
    })
    .catch((error) => {
      console.log(error);
    });
  return true;
};
export const GetCartData =
  (Tableno, tableGroup, target) => (dispatch, getstate) => {
    var Loading = true;
    dispatch({ type: ActionTypes.SET_LOADING, payload: Loading });
    const oldtext = target.innerHTML;
    target.innerHTML = "Loading...";
    const Table = getstate().Cart.Table;
    const subTable = Table.group.find(
      (p) => p.id.toLowerCase().indexOf(tableGroup.toLowerCase()) >= 0
    );
    const OpenStatus = subTable["tables"].find((items) => items.current === 1);
    const index = subTable["tables"].indexOf(OpenStatus);
    if (index >= 0) {
      const value = subTable["tables"][index];
      value.current = 0;
    }
    const set = subTable["tables"].find((items) => items.table === Tableno);
    const ind = subTable["tables"].indexOf(set);
    const val = subTable["tables"][ind];
    val.current = 1;
    ApiConnect.get(`POS/Inventory/TableDetailInfo?table=` + Tableno)
      .then((response) => {
        target.innerHTML = oldtext;
        const CurrentCart = response.data;
        dispatch({
          type: ActionTypes.SET_CURRENT_CART,
          payload: { CurrentCart },
        });
        dispatch(CartSocketRefresh());
        dispatch({ type: ActionTypes.SET_LOADING, payload: (Loading = false) });
        const OldCart = response.data.order;
        dispatch({ type: ActionTypes.CARTDATAOLD, payload: { OldCart } });
      })
      .catch((error) => {
        console.log(error);
        dispatch({ type: ActionTypes.SET_LOADING, payload: (Loading = false) });
      });
    dispatch({ type: ActionTypes.UPDATE_TABLE_DATA, payload: { Table } });
  };
export const addToCart =
  (product, palce, note, qty) => (dispatch, getstate) => {
    let alreadyExists = false;
    const Cart = getstate().Cart.CurrentCart;
    if (!Cart) {
      return;
    }
    const Order = Cart.order.slice();
    const Note = note || "";
    const Place = palce || 0;
    Order.forEach((x) => {
      if (
        x.prodid === product.id &&
        x.prdnote === Note &&
        x.orderplace === Place
      ) {
        alreadyExists = true;
        x.qty = x.qty + 1;
        x.price = product.price;
        toast.info(product.name + " Updated To Cart", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          draggableDirection: "y",
        });
      }
    });
    if (!alreadyExists) {
      let newdata = {
        name: product.name,
        price: product.price,
        qty: qty,
        prodid: product.id,
        image: product.image,
        prdnote: Note,
        orderplace: Place,
      };
      Order.push({ ...newdata });
      toast.info(product.name + " Added To Cart", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        draggableDirection: "y",
      });
    }
    const CurrentCart = Cart;
    CurrentCart.order = Order;
    dispatch({ type: ActionTypes.ADD_TO_CART, payload: { CurrentCart } });
    dispatch(CalculateCartTotal());
    dispatch(mostRecentAdd(product));
  };
export const incrementToCart =
  (product, note, place) => (dispatch, getstate) => {
    const Cart = getstate().Cart.CurrentCart;
    const Order = Cart.order.slice();
    const Note = note;
    const Place = place;
    const selectProduct = Order.find(
      (items) =>
        items.prodid === product &&
        items.prdnote === Note &&
        items.orderplace === Place
    );
    const index = Order.indexOf(selectProduct);
    const value = Order[index];
    value.qty = parseInt(value.qty) + 1;
    const CurrentCart = Cart;
    CurrentCart.order = Order;
    dispatch({
      type: ActionTypes.INCREASE_QUANTITY_CART,
      payload: { CurrentCart },
    });
    dispatch(CalculateCartTotal());
    // dispatch(mostRecentAdd(product));
  };
export const decrementToCart =
  (product, note, place) => (dispatch, getstate) => {
    const Cart = getstate().Cart.CurrentCart;
    let Order = Cart.order.slice();
    const selectProduct = Order.find(
      (items) =>
        items.prodid === product &&
        items.prdnote === note &&
        items.orderplace === place
    );
    const index = Order.indexOf(selectProduct);
    const value = Order[index];

    if (value.qty > 1) {
      value.qty = parseInt(value.qty) - 1;
    } else {
      Order.splice(index, 1);
    }
    const CurrentCart = Cart;
    CurrentCart.order = Order;
    dispatch({
      type: ActionTypes.DECREASE_QUANTITY_CART,
      payload: { CurrentCart },
    });
    dispatch(CalculateCartTotal());
  };
export const removeItemFromCart =
  (product, note, place) => (dispatch, getstate) => {
    const Cart = getstate().Cart.CurrentCart;
    let Order = Cart.order.slice();
    const selectProduct = Order.find(
      (items) =>
        items.prodid === product &&
        items.prdnote === note &&
        items.orderplace === place
    );
    const index = Order.indexOf(selectProduct);
    Order.splice(index, 1);
    const CurrentCart = Cart;
    CurrentCart.order = Order;
    dispatch({ type: ActionTypes.REMOVE_FROM_CART, payload: { CurrentCart } });
    dispatch(CalculateCartTotal());
  };
export const PlaceTableOrder = () => (dispatch, getstate) => {
  var Loading = true;
  dispatch({ type: ActionTypes.SET_LOADING, payload: Loading });
  const CurrentCart = getstate().Cart.CurrentCart;
  var bodyFormData = new FormData();
  bodyFormData.append("table", CurrentCart.table);
  bodyFormData.append("orderid", CurrentCart.order_id);
  bodyFormData.append("order", JSON.stringify(CurrentCart.order));
  bodyFormData.append("discount", JSON.stringify(CurrentCart.discount));
  bodyFormData.append(
    "membership",
    CurrentCart.membership.length !== 0 ? CurrentCart.membership.id : false
  );
  ApiConnect({
    method: "post",
    url: "/POS/Inventory/PlaceTableOrder",
    data: bodyFormData,
  })
    .then((response) => {
      toast.success("Order Placed", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        draggableDirection: "y",
      });
      dispatch({ type: ActionTypes.SET_LOADING, payload: (Loading = false) });
      dispatch(CartSocketRefresh());
    })
    .catch((error) => {
      console.log(error);
      dispatch({ type: ActionTypes.SET_LOADING, payload: (Loading = false) });
    });
};

export const ViewTable = (group) => (dispatch, getstate) => {
  const tableGroup = getstate().Cart.Table.group;
  const selecttable = tableGroup.filter(
    (p) => p.id.toLowerCase().indexOf(group.toLowerCase()) >= 0
  )[0]["tables"];
  const Table = {
    group: tableGroup,
    table: selecttable,
  };
  dispatch({ type: ActionTypes.SET_SELECT_DATA, payload: { Table } });
};
export const CartSocketRefresh = () => (dispatch, getstate) => {
  dispatch(cartUpdate());
  // const client = new W3CWebSocket(
  //   `wss://${process.env.REACT_APP_API_URL}/Websocket/`
  // );
  // var WsData = {
  //   Authkey: process.env.REACT_APP_API_KEY,
  //   Token: getstate().Auth.Token,
  //   Table: getstate().Cart.CurrentCart.table,
  //   OrderID: getstate().Cart.CurrentCart.order_id,
  // };
  // const CurntTablGrp =
  //   getstate().Cart.Table.table.length !== 0
  //     ? getstate().Cart.Table.table[0].groupid
  //     : false;
  // client.onopen = (e) => {
  //   client.send(JSON.stringify(WsData));
  //   console.log("Socket Connected");
  // };
  // client.onerror = (e) => {
  //   console.log("error", e);
  //   client.close();
  // };
  // client.onclose = (e) => {
  //   setTimeout(function () {
  //     dispatch(CartSocketRefresh());
  //   }, 1000);
  //   console.log("socket closed try again");
  //   // dispatch(CartSocketRefresh())
  // };
  // client.onmessage = (e) => {
  //   const data = JSON.parse(e.data);
  //   if (data.type === "table") {
  //     const Table = {
  //       group: data.message,
  //       table: [],
  //     };
  //     dispatch({ type: ActionTypes.SET_TABLE_DATA, payload: { Table } });
  //     if (CurntTablGrp) {
  //       dispatch(ViewTable(CurntTablGrp));
  //     }
  //   }
  //   if (data.type === "cart") {
  //     const CurrentCart = data.message;
  //     dispatch({
  //       type: ActionTypes.SET_CURRENT_CART,
  //       payload: { CurrentCart },
  //     });
  //   }
  // };
};

export const RefreshTable = () => (dispatch, getstate) => {
  var Loading = true;
  const currentTable = getstate().Cart.Table.table;
  dispatch({ type: ActionTypes.SET_LOADING, payload: Loading });
  const CurrentCart = [];
  ApiConnect.get(`POS/Inventory/TableStatus`)
    .then((response) => {
      dispatch({ type: ActionTypes.SET_LOADING, payload: (Loading = false) });
      const Table = {
        group: response.data,
        table: [],
      };
      dispatch({ type: ActionTypes.SET_TABLE_DATA, payload: { Table } });
      if (currentTable.length > 0) {
        dispatch(ViewTable(currentTable[0].groupid));
      }
    })
    .catch((error) => {
      console.log(error);
      dispatch({ type: ActionTypes.SET_LOADING, payload: (Loading = false) });
    });
  dispatch({ type: ActionTypes.EMPTY_CURRENT_CART, payload: { CurrentCart } });
};

export const CalculateCartTotal = () => (dispatch, getstate) => {
  const CurrentCart = getstate().Cart.CurrentCart || [];
  const subtotal = parseFloat(
    CurrentCart.order.reduce((sum, i) => (sum += i.qty * i.price), 0)
  );
  const disDetails = CurrentCart.discount ? CurrentCart.discount : null;
  let discountAmt = 0;
  let tax = 0;
  if (parseFloat(CurrentCart.tax_per) !== 0) {
    tax = (subtotal * parseFloat(CurrentCart.tax_per)) / 100;
  }
  const servicecharge = (subtotal * parseFloat(CurrentCart.service)) / 100;
  const netTotal = parseFloat(subtotal + tax + servicecharge);
  switch (disDetails.type) {
    case "amount":
      discountAmt = disDetails.amount;
      break;
    case "percentage":
      discountAmt = (netTotal * parseFloat(disDetails.percentage)) / 100;
      break;
    case "code":
      discountAmt =
        disDetails.percentage !== 0
          ? (netTotal * parseFloat(disDetails.percentage)) / 100
          : disDetails.amount;
      break;
    case "membership":
      discountAmt =
        disDetails.percentage !== 0
          ? (netTotal * parseFloat(disDetails.percentage)) / 100
          : disDetails.amount;
      break;
  }
  const netamount = netTotal - discountAmt;
  CurrentCart.subtotal = subtotal.toFixed(2);
  CurrentCart.total = netamount.toFixed(2);
  CurrentCart.tax = tax.toFixed(2);
  CurrentCart.discount.amount = discountAmt;
  CurrentCart.charge = servicecharge.toFixed(2);
  dispatch({ type: ActionTypes.CALCULATE_CART, payload: { CurrentCart } });
};
export const AddMembership = (member) => (dispatch, getstate) => {
  const CurrentCart = getstate().Cart.CurrentCart;
  CurrentCart.membership = member;
  dispatch({
    type: ActionTypes.SET_MEMBERSHIP,
    payload: { CurrentCart },
  });
};
export const TenderChange = (tender, change) => (dispatch, getstate) => {
  const CurrentCart = getstate().Cart.CurrentCart;
  CurrentCart.tender = tender;
  CurrentCart.change = change;
  CurrentCart.payment.type = "cash";
  CurrentCart.payment.amount = tender;
  dispatch({ type: ActionTypes.SET_TENDER, payload: { CurrentCart } });
};

export const OtherPayment = (type, amount, tid) => (dispatch, getstate) => {
  const CurrentCart = getstate().Cart.CurrentCart;
  CurrentCart.payment.type = type;
  CurrentCart.payment.amount = amount;
  if (type === "Account") {
    CurrentCart.payment.account = tid;
  } else {
    CurrentCart.payment.tid = tid;
  }
  dispatch({ type: ActionTypes.SET_PAYMENT, payload: { CurrentCart } });
};
export const UpdatePayment = (type, amount, tid) => (dispatch, getstate) => {
  const CurrentCart = getstate().Cart.CurrentCart;
  CurrentCart.payment.type = type;
  CurrentCart.payment.amount = amount;
  CurrentCart.payment.tid = tid;
  dispatch({ type: ActionTypes.UPDATE_PAYMENT, payload: { CurrentCart } });
};
export const applyDiscount =
  (method, amount, perCent, disMessage, reffCode) => (dispatch, getstate) => {
    const CurrentCart = getstate().Cart.CurrentCart;
    CurrentCart.discount.type = method;
    CurrentCart.discount.percentage = perCent;
    CurrentCart.discount.amount = amount;
    CurrentCart.discount.message = disMessage;
    CurrentCart.discount.code = reffCode;
    dispatch({
      type: ActionTypes.DISCOUNT_CURRENT_CART,
      payload: { CurrentCart },
    });
    dispatch(CalculateCartTotal());
  };

export const CheckoutCurrentCart =
  (SuccessCheckout, contact, email) => (dispatch, getstate) => {
    var Loading = true;
    dispatch({ type: ActionTypes.SET_LOADING, payload: Loading });
    const CurrentCart = getstate().Cart.CurrentCart;
    if (CurrentCart.order_id) {
      ApiConnect.put(
        `POS/Checkout/VerifyCheckout?orderid=${CurrentCart.order_id}&type=${CurrentCart.payment.type ? CurrentCart.payment.type : "cash"
        }&tid=${CurrentCart.payment.tid}&table=${CurrentCart.table
        }&email=${email}&contact=${contact}&account=${CurrentCart.payment.account || ""
        }&membership=${CurrentCart.membership.length !== 0 ? CurrentCart.membership.id : ""
        }`
      )
        .then((response) => {
          if (response.data.status === 201) {
            toast.info(response.data.message, {
              position: "bottom-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              draggableDirection: "y",
            });
            dispatch(SuccessCheckout(response.data.invoice));
          } else {
            toast.error(response.data.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              draggableDirection: "y",
            });
          }
          // dispatch(setCartToDefault());
          dispatch({
            type: ActionTypes.SET_LOADING,
            payload: (Loading = false),
          });
        })
        .catch((error) => {
          console.log(error);
          dispatch({
            type: ActionTypes.SET_LOADING,
            payload: (Loading = false),
          });
        });
    } else {
      dispatch({
        type: ActionTypes.SET_LOADING,
        payload: (Loading = false),
      });
      toast.info("No Cart To Checkout", {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        draggableDirection: "y",
      });
    }
  };

export const SetCartToDefault = () => (dispatch) => {
  dispatch(RefreshTable());
  dispatch({
    type: ActionTypes.SET_CURRENT_CART,
    payload: { CurrentCart: [] },
  });
  dispatch(CartSocketRefresh());
};
export const mostRecentAdd = (product) => (dispatch) => {
  var oldData = localStorage.MostRecent || false;
  oldData = JSON.parse(oldData);
  if (!oldData) {
    const value = product;
    value.count = parseInt(value.count || 0) + 1;
    localStorage.setItem("MostRecent", JSON.stringify([value]));
  } else {
    const RecentView = oldData.slice();
    const selectProduct = oldData.find((items) => items.id === product.id);
    if (!selectProduct) {
      const Newvalue = product;
      Newvalue.count = parseInt(Newvalue.count || 0) + 1;
      RecentView.push({ ...Newvalue });
    } else {
      const index = RecentView.indexOf(selectProduct);
      const value = RecentView[index];
      value.count = parseInt(value.count || 0) + 1;
    }
    RecentView.sort((a, b) => {
      return b.count - a.count;
    });
    localStorage.setItem("MostRecent", JSON.stringify(RecentView));
    dispatch({ type: ActionTypes.SET_RECENTLY_ADDED, payload: { RecentView } });
  }
};
